<template>
  <v-card class="elevation-0">
    <v-row class="pa-0 ma-0">
      <v-col cols="6">
        <v-card>
          <div
            v-if="isUrlValid"
            class="d-flex justify-center align-center"
            style="position: relative; height: 200px"
          >
            <iframe class="website-preview" :src="`${previewUrl}`" />
          </div>

          <v-img
            v-else
            class="align-end text-white"
            height="200"
            src="website-specs.webp"
            contain
          />
          <v-card-text>
            <div class="mt-4">
              <v-row>
                <v-col cols="12">
                  <HelpFormInput
                    v-model="url"
                    label="URL"
                    placeholder="URL"
                    help-text="The URL of the website."
                    :rules="rules.url"
                    @update:model-value="onUrlChange"
                  />
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card>
          <!-- <v-img
            class="align-end text-white"
            height="200"
            src="website-specs.webp"
            contain
          /> -->
          <v-card-text>
            <div class="mt-4">
              <v-row>
                <v-col cols="12">
                  <HelpFormInput
                    v-model="name"
                    label="Inventory Name"
                    placeholder="Inventory Name"
                    help-text="Give recognizable name to your Inventory Item."
                    :rules="rules.name"
                    @update:model-value="
                      (v) =>
                        onUpdate({
                          ...modelValue,
                          name: v,
                        })
                    "
                  />
                </v-col>
                <v-col cols="12">
                  <HelpFormSwitch
                    v-model="mobileDeviceSupport"
                    label="Mobile Device Support"
                    help-text="Enable if the website is mobile device friendly."
                    @update:model-value="
                      (v) =>
                        onUpdate({
                          ...modelValue,
                          mobileDeviceSupport: v,
                        })
                    "
                  />
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
    
    
    
    
    <script>
import HelpFormInput from "../../atoms/common/inputs/HelpFormInput.vue";
import HelpFormSwitch from "../../atoms/common/inputs/HelpFormSwitch.vue";

export default {
  components: {
    HelpFormInput,
    HelpFormSwitch,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
      default: () => ({
        name: null,
        description: null,
        url: null,
        mobileDeviceSupport: null,
      }),
    },
  },
  emits: ["next", "update:modelValue"],

  data() {
    return {
      name: null,
      description: null,
      url: null,
      mobileDeviceSupport: null,

      previewTimeout: null,
      previewUrl: null,
      rules: {
        name: [
          (v) => !!v || "Name is required",
          (v) =>
            (v && v.length <= 50) || "Name must be less than 50 characters",
        ],
        url: [
          (v) => !!v || "URL is required",
          (v) => {
            const regex = /^(ftp|http|https):\/\/[^ "]+$/;
            return regex.test(v) || "Invalid URL format";
          },
        ],
      },
    };
  },
  computed: {
    isUrlValid() {
      const regex = /^(ftp|http|https):\/\/[^ "]+$/;
      return regex.test(this.previewUrl);
    },
  },

  created() {},
  methods: {
    onUpdate(value) {
      this.$emit("update:modelValue", value);
    },
    onUrlChange(value) {
      this.url = value;
      this.$emit("update:modelValue", {
        ...this.modelValue,
        url: value,
      });

      if (this.previewTimeout) {
        clearTimeout(this.previewTimeout);
      }

      this.previewTimeout = setTimeout(() => {
        this.previewUrl = value;
        this.tryToGetURL();
      }, 300);
    },
    async tryToGetURL() {
      try {
        const response = await fetch(this.previewUrl); // Must support CORS
        const html = await response.text();
        const match = html.match(/<title>(.*?)<\/title>/i);
        const result = match ? match[1] : "";

        console.log("Title:", result);
      } catch (error) {
        console.error("Fetch failed:", error);
        return "Unable to fetch title";
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.website-preview {
  transform: scale(calc(100% / 4));
  transform-origin: top left;
  width: calc(100% * 4);
  height: 800px;
  border: none;
  position: absolute;
  left: 0;
  top: 0;
}
</style>